import styled from "@emotion/styled";

export const IconContainer = styled.div`
  display: flex;
  column-gap: 0.25rem;
  align-items: center;
`;
